import API from "../utility/axios";
const apiUrl = '/api/v1';

export const GET_STUDENT_COUNT = (school_code: any): Promise<any[]> => {
    return API.get(`${apiUrl}/school/user/count?school_code=${school_code}`);
}

